import { useMutation } from 'react-query';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { httpService } from '../../../../../services/http.service';
import { BASE_URL } from '../../../../../constants/endpoints';
import { useStore } from '../../../../../store';
import { IServerErrorResponse } from '../../../../../types';
import { flattenServerErrorResponse } from '../../../../../helpers/errors.helper';
import i18next from '../../../../../i18n/i18n';

interface IProps {
  file: File;
}
export const useUploadFileToOcr = () => {
  const {
    getPersonalAccount,
    user: { customerId },
  } = useStore((state) => state);
  const { accountExternalId } = getPersonalAccount();
  const [abortController, setAbortController] = useState(new AbortController());

  const cancelReq = () => {
    abortController.abort();
    setTimeout(() => {
      // ** In case to keep using this mutation after cancel, we must reset the signal provider */
      setAbortController(new AbortController());
    }, 1000);
  };

  return {
    cancelReq,
    mutation: useMutation(
      'useUploadFileToOcr',
      async ({ file }: IProps) => {
        const formData = new FormData();
        formData.append('document', file);
        const res = await httpService.post(
          `${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/document/ocr`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            signal: abortController.signal,
          },
        );
        return res.data;
      },
      {
        onError: (e: IServerErrorResponse) => {
          const { code } = flattenServerErrorResponse(e);
          const errorMsg =
            code === 50667 ? i18next.t('UPLOAD_BILL.UPLOAD_ERROR') : i18next.t('UPLOAD_BILL.UPLOAD_GENERAL_ERROR');
          toast.error(errorMsg, {
            position: 'bottom-center',
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        },
      },
    ),
  };
};
